import { render } from "./stock.vue?vue&type=template&id=b3e6a1b6"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
script.render = render

export default script